import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ExoplanetProvider } from './context/ExoplanetContext';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent';
import NotificationSystem from './components/NotificationSystem';
import HabitabilityAnalysis from './components/HabitabilityAnalysis';

function App() {
  const [activeSection, setActiveSection] = useState('habitability-analysis');
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  // Sidebar width: 256px (w-64) expanded, 80px (w-20) collapsed
  const sidebarWidth = sidebarExpanded ? 256 : 80;

  return (
    <ExoplanetProvider>
      <div className="App min-h-screen bg-black">
        <Header setActiveSection={setActiveSection} />
        <div className="flex">
          <Sidebar
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            expanded={sidebarExpanded}
            setExpanded={setSidebarExpanded}
          />
          <div
            className="flex-1 transition-all duration-300"
            style={{ marginLeft: sidebarWidth }}
          >
            {activeSection === 'habitability-analysis' ? (
              <HabitabilityAnalysis setActiveSection={setActiveSection} />
            ) : (
              <MainContent activeSection={activeSection} />
            )}
          </div>
        </div>
        <NotificationSystem />
      </div>
    </ExoplanetProvider>
  );
}

export default App; 